module.exports = __webpack_public_path__ + "static/media/huffpost-travel.d38d54e4.jpg";